import(/* webpackMode: "eager", webpackExports: ["BrandContent"] */ "/work/apps/frontend/src/features/brand/components/BrandContent.tsx");
